/* Aaria London UI behaviours.
 *
 * These four ran as inline <script> in sections/aaria-styles.liquid, which
 * sits in the header group, so 17KB of JavaScript was parser blocking on
 * every page and could not be cached between them. Every one of them
 * already waited on DOMContentLoaded, readyState or an observer before
 * touching anything, and a deferred script runs after parsing but before
 * DOMContentLoaded fires, so those listeners still catch it.
 *
 * The two blocks left inline are the ones that need Liquid values
 * (the shipping message and the video link), which a static file cannot see.
 *
 * Loaded with defer from aaria-styles.liquid. Anything added here must not
 * assume it runs before the DOM exists.
 */

/* ---- was inline at aaria-styles.liquid line 38 ---- */
(function () {
      var ticking = false;

      function update() {
        ticking = false;
        var bar = document.querySelector('product-sticky-bar');
        if (!bar) return;

        var name = bar.getAttribute('form');
        var form = (name && document.forms[name]) ||
                   document.querySelector('[data-block-type="buy-buttons"] form');
        if (!form) return;

        var rect = form.getBoundingClientRect();
        if (!rect.height && !rect.width) return;

        if (window.pageYOffset < window.innerHeight) {
          bar.classList.remove('aaria-sticky-on');
          return;
        }

        var footer = document.querySelector('.shopify-section--footer');
        var footerShowing = footer
          ? footer.getBoundingClientRect().top < window.innerHeight
          : false;

        bar.classList.toggle('aaria-sticky-on', rect.bottom < 0 && !footerShowing);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', update);
      update();
    })();

/* ---- was inline at aaria-styles.liquid line 102 ---- */
(function () {
      var KEEP = 5;

      function init() {
        var carousel = document.querySelector(
          '.shopify-section--main-product .product-gallery__carousel'
        );
        if (!carousel || carousel.dataset.aariaCapped) return;

        // Only the media Prestige is actually showing. Counting the
        // hidden ones would cap the column short.
        var media = [].slice.call(
          carousel.querySelectorAll('.product-gallery__media:not([hidden])')
        );

        // The first one is the pinned hero in column one, so the cap
        // applies to what follows it.
        if (media.length <= KEEP + 1) return;
        carousel.dataset.aariaCapped = '1';

        media.slice(KEEP + 1).forEach(function (el) {
          el.setAttribute('data-aaria-more', '');
        });

        var more = 'View all ' + media.length + ' photos';
        var fewer = 'Show fewer';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'aaria-gallery__more';
        button.textContent = more;

        button.addEventListener('click', function () {
          var capped = carousel.classList.toggle('aaria-gallery--capped');
          button.textContent = capped ? more : fewer;
          // Collapsing from the bottom of a long column would leave the
          // viewport somewhere past the gallery, so come back to it.
          if (capped) {
            carousel.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
        });

        carousel.classList.add('aaria-gallery--capped');
        carousel.insertAdjacentElement('afterend', button);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();

/* ---- was inline at aaria-styles.liquid line 176 ---- */
(function () {
    // Order matters. "14K Rose Gold Vermeil" contains "gold", so rose
    // has to be tested before the plain gold catch all, and the two
    // tone names before silver for the same reason.
    //
    // Each is a highlight, a body and a lowlight rather than a flat
    // fill, because a flat swatch reads as a colour chip and these
    // need to read as metal. The 135deg run puts the highlight top
    // left, which is where the light sits on the product photography.
    var METALS = [
      [/rose\s*gold/i,                    'linear-gradient(135deg,#f7d9cc 8%,#dfa183 52%,#c07a5c)'],
      [/(mixed|duo\s*tone|two\s*tone)/i,  'linear-gradient(135deg,#e9c65e 0 48%,#cfcfcf 52% 100%)'],
      [/(sterling|silver|rhodium|platinum)/i, 'linear-gradient(135deg,#fbfbfb 8%,#cdcdcd 52%,#a8a8a8)'],
      [/gold/i,                            'linear-gradient(135deg,#f6e3a4 8%,#dcb44f 52%,#b38c30)']
    ];
    function gradientFor(name) {
      for (var i = 0; i < METALS.length; i++) {
        if (METALS[i][0].test(name)) return METALS[i][1];
      }
      return null;
    }

    // Rebuy wraps each radio and its label in one swatch div, in that
    // order, so the label is the next sibling. The parent lookup is
    // the fallback if that markup ever changes.
    function labelFor(input) {
      var next = input.nextElementSibling;
      if (next && next.tagName === 'LABEL') return next;
      return input.parentNode ? input.parentNode.querySelector('label') : null;
    }

    function paintBlock(block) {
      var groups = block.querySelectorAll(
        '.rebuy-product-options__button-swatches, .rebuy-size-swatches'
      );

      for (var g = 0; g < groups.length; g++) {
        var group = groups[g];
        var colours = group.querySelectorAll('input.rebuy-color-input');

        // One value is not a choice. Flagged here rather than in CSS
        // because Rebuy nests each swatch in an unclassed wrapper, so
        // there is no reliable structural selector to count them with.
        var total = group.querySelectorAll('input').length;
        if (total < 2) {
          group.setAttribute('data-aaria-single', '1');
        } else {
          group.removeAttribute('data-aaria-single');
        }

        // No colour inputs means this is the style option. Tagging it
        // is enough: the CSS turns it into pills.
        if (!colours.length) {
          group.setAttribute('data-aaria-swatches', 'style');
          continue;
        }

        group.setAttribute('data-aaria-swatches', 'metal');

        // Metals sit on their own row directly under the image, at the
        // left edge of the card, above the style pills.
        //
        // They used to be lifted up onto the price line instead, to
        // save a row on a phone. That cost more than it saved. The
        // price line lives in the second grid column, which is 86px
        // wide in the desktop drawer, and three circles need 108px, so
        // the third was sliced off by the edge of the panel. The
        // options row spans both columns, 180px, and fits four with
        // room over.
        //
        // The row costs about 11px of card height. Worth it to have
        // every metal a customer can actually choose be visible.
        //
        // Rebuy rebuilds these cards whenever the cart changes, so this
        // has to be repeated rather than done once. Moving a node keeps
        // its listeners, and the sync below still finds the radios by
        // searching the whole block, so nothing else has to know.
        var optionsRow = block.querySelector('.rebuy-product-options');
        var swatchHome = optionsRow
          ? optionsRow.querySelector('.rebuy-product-options__button-swatches-container') || optionsRow
          : null;
        if (swatchHome && group.parentNode !== swatchHome) {
          swatchHome.insertBefore(group, swatchHome.firstChild);
        }

        for (var k = 0; k < colours.length; k++) {
          var value = colours[k].value || '';
          var label = labelFor(colours[k]);
          if (!label) continue;

          var grad = gradientFor(value);
          if (!grad) {
            // Not a metal we know. Leave it as a pill with its text
            // rather than painting a circle that says nothing.
            label.removeAttribute('data-aaria-metal');
            continue;
          }

          // Rebuy re-renders on cart changes and wipes inline styles,
          // so this repaints rather than skipping already done blocks.
          label.style.backgroundImage = grad;
          label.setAttribute('title', value);
          label.setAttribute('data-aaria-metal', '1');
        }
      }
    }

    // Every option the card currently has selected, in Rebuy's own
    // words: ["Sterling Silver", "Single Earring"].
    function chosenValues(block) {
      var chosen = [];
      var checked = block.querySelectorAll(
        'input.rebuy-color-input:checked, input.rebuy-size-input:checked'
      );
      for (var i = 0; i < checked.length; i++) {
        var v = (checked[i].value || '').trim();
        if (v) chosen.push(v);
      }
      return chosen;
    }

    // Rebuy's ADD button reads the select, so the select has to follow
    // the swatches. The option text is the variant, "14K Gold Plated /
    // Single Earring", so the chosen values are matched against its
    // slash separated parts.
    function syncSelect(block) {
      var select = block.querySelector('select');
      if (!select) return;

      var chosen = chosenValues(block);
      if (!chosen.length) return;

      for (var o = 0; o < select.options.length; o++) {
        var parts = (select.options[o].textContent || '').split('/');
        for (var p = 0; p < parts.length; p++) parts[p] = parts[p].trim();

        var all = true;
        for (var c = 0; c < chosen.length; c++) {
          if (parts.indexOf(chosen[c]) === -1) { all = false; break; }
        }
        if (!all) continue;

        if (select.value !== select.options[o].value) {
          select.value = select.options[o].value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    // Picking a metal should show that metal. Rebuy does not swap the
    // card image itself, so the variant's own photo is looked up and
    // put in place.
    //
    // The variant images are not in the markup, so they come from
    // /products/handle.js, fetched on the first swatch click rather
    // than up front: no card pays for this until someone uses it, and
    // the result is cached for every other card on the same product.
    var productCache = {};

    function handleFor(block) {
      var link = block.querySelector('a[href*="/products/"]');
      if (!link) return null;
      var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    // Never hand the CDN a full size image for an 84px slot. Asking
    // for 200 covers the retina case and nothing more.
    function sized(src, width) {
      try {
        var url = new URL(src, window.location.origin);
        url.searchParams.set('width', width);
        return url.toString();
      } catch (e) {
        return src;
      }
    }

    function applyImage(block, product) {
      var chosen = chosenValues(block);
      if (!chosen.length || !product || !product.variants) return;

      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var options = variant.options || [];

        var all = true;
        for (var c = 0; c < chosen.length; c++) {
          if (options.indexOf(chosen[c]) === -1) { all = false; break; }
        }
        if (!all) continue;

        // A variant with no image of its own keeps the one showing,
        // which is better than falling back to the product default and
        // flicking the card between two photos.
        if (!variant.featured_image || !variant.featured_image.src) return;

        var img = block.querySelector('.rebuy-product-media img') ||
                  block.querySelector('img');
        if (!img) return;

        // The srcset would otherwise win and put the old image back.
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.src = sized(variant.featured_image.src, 200);
        return;
      }
    }

    function swapImage(block) {
      var handle = handleFor(block);
      if (!handle) return;

      if (productCache[handle]) {
        applyImage(block, productCache[handle]);
        return;
      }

      fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (!product) return;
          productCache[handle] = product;
          applyImage(block, product);
        })
        .catch(function () { /* leave the image as it is */ });
    }

    function scan(root) {
      var blocks = (root || document).querySelectorAll('.rebuy-product-block');
      for (var i = 0; i < blocks.length; i++) paintBlock(blocks[i]);
    }

    function start() {
      scan(document);

      // Delegated, so it survives every Rebuy re-render without
      // rebinding. The listener is on the radios, and it writes to the
      // select, so dispatching change there cannot come back round.
      //
      // Click as well as change: the radio is driven by its label, and
      // a component that stops change from bubbling would otherwise
      // leave the card showing the wrong metal. Both call the same two
      // functions, and both are idempotent, so firing twice is fine.
      function onSwatch(event) {
        var el = event.target;
        if (!el || !el.closest) return;

        var swatch = el.closest('.rebuy-product-options__button-swatch');
        if (!swatch) return;

        var block = swatch.closest('.rebuy-product-block');
        if (!block) return;

        // After the label has handed the radio its new state.
        window.setTimeout(function () {
          syncSelect(block);
          swapImage(block);
        }, 0);
      }

      document.addEventListener('change', onSwatch);
      document.addEventListener('click', onSwatch);

      if (!window.MutationObserver) return;
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) scan(added[j]);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

/* ---- was inline at aaria-styles.liquid line 693 ---- */
(function () {
      // Pixels per second, not per frame. Per frame meant the drift ran at
      // whatever rate the screen refreshed at, so a 120Hz iPhone moved the
      // logos twice as fast as a 60Hz one from the same number. This is the
      // same speed on both.
      var SPEED = 36;

      function init() {
        if (!window.matchMedia('(max-width: 699px)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var row = document.querySelector('.shopify-section--logo-list .logo-list');
        if (!row || row.dataset.aariaMarquee) return;

        var items = [].slice.call(row.children);
        if (items.length < 2) return;

        // Nothing to creep along if the row already fits.
        if (row.scrollWidth <= row.clientWidth + 4) return;

        row.dataset.aariaMarquee = '1';

        items.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          row.appendChild(clone);
        });

        var paused = false;
        var resumeTimer = null;

        function hold() {
          paused = true;
          window.clearTimeout(resumeTimer);
          // Long enough that it does not fight someone reading the row.
          resumeTimer = window.setTimeout(function () { paused = false; }, 2500);
        }

        row.addEventListener('pointerdown', hold, { passive: true });
        row.addEventListener('touchstart', hold, { passive: true });
        row.addEventListener('wheel', hold, { passive: true });

        // Stop entirely when the row is off screen, so a homepage left
        // open in a background tab is not animating to nobody.
        var onScreen = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            onScreen = entries[0].isIntersecting;
          }).observe(row);
        }

        var last = null;

        // The position is kept here as a float and only ever written to the
        // element. Reading scrollLeft back each frame was the bug: the
        // browser rounds it, so at a fraction of a pixel per frame the
        // remainder was thrown away every time and the row crawled or sat
        // still. Holding the true position and writing it out keeps the
        // motion smooth at any speed.
        var pos = row.scrollLeft;

        function tick(now) {
          if (last === null) last = now;
          var elapsed = Math.min(now - last, 100); // a backgrounded tab must not lurch
          last = now;

          if (paused || !onScreen) {
            // Pick up wherever a finger left it.
            pos = row.scrollLeft;
          } else {
            var half = row.scrollWidth / 2;
            pos += (SPEED * elapsed) / 1000;
            if (pos >= half) pos -= half;
            row.scrollLeft = pos;
          }

          window.requestAnimationFrame(tick);
        }

        window.requestAnimationFrame(tick);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      window.addEventListener('load', init);
    })();

/* ===================================================================
   Prose blocks that break the product grid.

   A section is a sibling of the grid in the document, so "after the
   second row of products" cannot be expressed in the template or in
   CSS. Any block carrying data-aaria-break-grid-after is moved into
   the grid after that many cards, and spans every column via
   .product-list > .aaria-prose in aaria.css.

   The move happens below the fold, so nothing visible shifts and it
   costs no layout stability. With JavaScript off the block stays
   where the template put it, which still reads correctly, just after
   the grid rather than inside it.

   Re-run when the grid is replaced, which happens on every filter and
   sort, or the block is left behind in the old markup.
   =================================================================== */
(() => {
  const movers = document.querySelectorAll('[data-aaria-break-grid-after]');
  if (movers.length === 0) return;

  const place = () => {
    const grid = document.querySelector('.product-list');
    if (!grid) return;

    movers.forEach((block) => {
      const after = parseInt(block.getAttribute('data-aaria-break-grid-after'), 10);
      if (!after || after < 1) return;

      const cards = [...grid.children].filter((child) => !child.hasAttribute('data-aaria-break-grid-after'));
      // Fewer products than the break point means there is no second
      // row to break, so the block stays below the grid.
      if (cards.length <= after) return;

      const target = cards[after];
      if (target && block.nextElementSibling !== target) grid.insertBefore(block, target);
    });
  };

  place();

  const grid = document.querySelector('.product-list');
  if (grid && 'MutationObserver' in window) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; place(); });
    }).observe(grid, { childList: true });
  }
})();
